/**
 * Created by ferto
 * Marciano Digital Agency
 * www.marciano.com.mx
 * Date: 01/02/2018.
 *
 * index Vue Store
 */
import BaseStore from '@/store/base-store'
const options = {
  state: {
    items: [{'name': 'A'}, {'name': 'B'}, {'name': 'C'}, {'name': 'D'}, {'name': 'E'}]
  }
}
export default new BaseStore('dealer-types', options)



// WEBPACK FOOTER //
// ./src/store/branch-types/index.js